/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Auto_Rate_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Automatically calculate Speed and render audio" |
*
* @param {Event_Ad_Auto_Rate_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_auto_rate_aria_label = /** @type {((inputs?: Event_Ad_Auto_Rate_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Auto_Rate_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calculer automatiquement la vitesse et générer l'audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tempo automatisch berechnen und Audio rendern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcola automaticamente la velocità e genera l'audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматически рассчитать скорость воспроизведения и озвучить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calcula automáticamente la velocidad y renderiza el audio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动计算播放速度并渲染音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生速度を自動的に計算してオーディオをレンダリングします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित रूप से गति की गणना करें और ऑडियो प्रस्तुत करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calcular automaticamente a velocidade e renderizar áudio")
	return /** @type {LocalizedString} */ ("Automatically calculate Speed and render audio")
});